module.exports = __webpack_public_path__ + "img/rede-2025-04.9baf446b.jpg";